/* Router */

import Landing from './views/landing.vue';
import Cover from './views/cover.vue';
import Share from './views/share.vue';
import Stories from './views/stories.vue';
import Story from './views/story.vue';
import Default from './views/default.vue';
import Guide from './views/guide.vue';


export default [
  {
    path: '/',
    component: Landing,
    children: [
      {
        path: '',
        components: {
          main: Cover
        }
      },
      {
        path: 'stories',
        components: {
          main: Cover,
          middleman: Stories,
        }
      },
      {
        path: 'stories/:story',
        components: {
          main: Cover,
          middleman: Stories,
          overlay: Story
        }
      },
      {
        path: ':default',
        components: {
          middleman: Default
        }
      },
      {
        name: 'guide',
        path: ':default/:guide',
        components: {
          middleman: Default,
          overlay: Guide
        }
      },
    ]
  },
]
